module.exports = __webpack_public_path__ + "startpage-be63061f/templates-preview-2x-b33d8e71a43955064ad13e183c6b55e8.png";